import React, { useEffect, useRef } from 'react';
import { useQuery } from "@apollo/client";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';

import { publicKeys } from '../../../config/stripeConfig';
import { useAppState } from "../../contexts/AppContext";
import { GET_COUNTRY_CODE } from '../../includes/queries';

type Props = {
    children?: React.ReactNode,
};

const StripeLoader: React.FC<Props> = ({ children }) => {
    const stripeKey = useRef('none');
    const [appState, setAppState] = useAppState();
    const countryCode = appState.user?.CountryCodeFromIp || appState.country.codeFromIP;

    const { data } = useQuery(GET_COUNTRY_CODE, {
        context: {
            clientName: "corporate",
        }
    });

    useEffect(() => {
        if (data?.countryCodes && countryCode) {
            setAppState({
                currency: data.countryCodes.find(
                    (country: any) => country.code === countryCode.toLowerCase()
                )?.currency || '$'
            })
        }
    }, [data, countryCode, setAppState]);

    stripeKey.current = (
        publicKeys.find(keySet => keySet.country === countryCode)?.key ??
        publicKeys.find(keySet => keySet.country === 'default')?.key
    ) || '';
    const stripePromise: any = loadStripe(stripeKey.current);

    if (!stripePromise) {
        return <div />;
    }

    return (
        // key is necessary to ensure Stripe updates country on country change.
        <Elements key={stripeKey.current} stripe={stripePromise}>
            {children}
        </Elements>
    );
};

export default StripeLoader;
